"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BottomContent = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var styled_components_1 = require("styled-components");
var styles_1 = require("../../styles");
var BottomContent = function (_a) {
    var children = _a.children;
    return (0, jsx_runtime_1.jsx)(StyledBottomText, __assign({ className: "twap-card-bottom-content" }, { children: children }));
};
exports.BottomContent = BottomContent;
var StyledBottomText = (0, styled_components_1.styled)(styles_1.StyledColumnFlex)({
    marginTop: 10,
    gap: 5,
    ".twap-warning-message": {
        gap: 5,
    },
    ".twap-warning-message-icon": {
        width: 18,
        height: 18,
        color: "rgb(255, 95, 82)",
    },
});
